import { createActions, createState, createReducer } from 'reduxsauce-crud'
import R from 'ramda'
import moment from 'moment'

const d = { deep: true }

/* ------------- Selectors ------------- */

const studentIndexes = (state, student, isTeacher) => {
    const classrooms = R.clone(state.get.results)
    const classroomIndex = isTeacher ? 0 : R.findIndex(R.propEq('id', student.classroom_id))(classrooms)
    const studentIndex = R.findIndex(R.propEq('id', student.id))(classrooms[classroomIndex].students)

    return {
        classroomIndex,
        studentIndex,
    }
}
const activeUser = (state, center_id) => {

        if (state.auth.user.role === 'Back Office Admin' || state.auth.user.role === 'Back Office MiAdvenio'|| state.auth.user.role === 'Back Office Talisis') {
            return state.auth.user.merge({ center_id: Number(center_id), d })
        } else {
            return state.auth.user
        }
    }
    /**
     * Search the redux store for the active classroom and return it.
     *
     * @param  {object} state  The Redux state
     * @return {object}
     */
const activeClassroom = ({ classrooms }) => {
    const classroomsArr = classrooms.get.results
    const activeClassroomIndex = R.findIndex(R.propEq('id', classrooms.activeClassroomId))(classroomsArr)

    return classroomsArr[activeClassroomIndex]
}

/**
 * Search the redux store for the active student within the active classroom
 * and return the student object.
 *
 * @param  {object} state  The Redux state
 * @return {object}
 */
const activeStudent = (state) => {
    const classroom = activeClassroom(state)
    const { activeStudentId } = state.classrooms

    if (!classroom) return {}

    const activeStudentIndex = R.findIndex(R.propEq('id', activeStudentId))(classroom.students)
    return activeStudentIndex > -1 ? classroom.students[activeStudentIndex] : { msg: 'not found' }
}

const activeStudentFromLocal = (state) => {
    const classrooms = R.clone(state.get.results)
    const { activeStudentId, activeClassroomId } = state
    const activeClassroomIndex = R.findIndex(R.propEq('id', activeClassroomId))(classrooms)
    const NurseRoomIndex = classrooms.findIndex(classroom => classroom.type === 'Sick Room')
    if (classrooms[activeClassroomIndex]) {
        const activeStudentIndex = R.findIndex(R.propEq('id', activeStudentId))(classrooms[activeClassroomIndex].students)
        return {
            student: classrooms[activeClassroomIndex].students[activeStudentIndex],
            activeClassroomIndex,
            activeStudentIndex,
            classrooms,
            NurseRoomIndex,
        }
    }
    return { classrooms }
}

const activeParent = (state) => {
    const student = activeStudent(state)
    const { parents } = student
    const { activeParentId } = state.classrooms

    if (Object.keys(student).length <= 0 || !parents) return {}

    let parentIndex = R.findIndex(R.propEq('userable_id', Number(activeParentId)))(parents)
    if (parentIndex < 0) {
        parentIndex = R.findIndex(R.propEq('id', Number(activeParentId)))(parents)
    }

    return parents[parentIndex]
}

const partners = (state) => {
    const classroom = activeClassroom(state)

    if (!classroom) return []

    return classroom.students
}

export const Selectors = {
    activeClassroom,
    activeParent,
    activeStudent,
    activeStudentFromLocal,
    partners,
    activeUser,
}

// Con updates de parent o de student, se va a manejar de la misma manera que el get
export const ClassroomRedux = createActions({
    updateStudentsStorage: ['newStudents'],
    getcenter: ['classroomId'],
    setActiveStudentId: ['id'],
    setActiveClassroomId: ['id'],
    setSearchName: ['name'],
    setActiveParentId: ['id'],
    setUserCenterid: ['id'],
    setCheckout: ['student_id', 'classroom_id', 'action'],
    getStudentProfileRequest: ['activeStudentId', 'activeClassroomId', 'timestamp', 'isCheckedOut'],
    getStudentProfileSuccess: ['profile', 'isCheckedOut'],
    getStudentProfileError: ['err'],
    getCenterRequest: ['classroomId'],
    getCenterSuccess: ['results'],
    getCenterError: ['error'],
    getClassroomRequest: ['centerId'],
    getClassroomSuccess: ['results'],
    getClassroomError: ['error'],
    getStudentActivitiesRequest: ['studentId'],
    getStudentActivitiesSuccess: ['results'],
    getStudentActivitiesError: ['error'],
    getStudentProfileErrorReset: [],
    setStudentProfile: [],
    sendMailInstitutionalRequest: ['activeParentId', 'activeStudentId'],
    sendMailInstitutionalSuccess: [''],
    sendMailInstitutionalError: ['err'],
    getParentProfileRequest: ['activeParentId', 'activeStudentId', 'timestamp'],
    getParentProfileSuccess: ['profile'],
    getParentProfileError: ['err'],
    getParentProfileErrorReset: [],
    updateStudentRequest: ['activeStudentId', 'profile', 'timestamp'],
    updateStudentSuccess: ['profile'],
    updateStudentAfterAddSibling: ['data'],
    updateParentRequest: ['activeParentId', 'activeStudentId', 'profile'],
    updateParentSuccess: ['profile'],
    updateCheckin: ['data', 'isTeacher'],
    updateVirtualCheckin: ['data', 'student'],
    updateDataAfterCheckin: ['data'],
    updateDataAfterCheckout: ['data', 'isTeacher'],
    updateChildActivity: ['data'],
    updateChildGroupActivity: ['data'],
    updateChildAfterFinishActivity: ['results'],
    deleteActivity: ['activityId'],
    deleteStudentRequest: ['studentId', 'deleteInfo'],
    deleteStudentSuccess: ['response'],
    deleteStudentError: ['error'],
    restoreStudentRequest: ['id'],
    restoreStudentSuccess: ['response'],
    restoreStudentError: ['error'],
    updateDataAfterInscription: ['data'],
    updateNotificationsStudent: ['disabled_notifications'],
    openSearchBar: null,
    getTotalStudents: null,
    closeSearchBar: null,
    searchValue: ['value'],
    resetError: [],
    resetClassroom: [],
    getStudentInvoicesRequest: ['id', 'queries'],
    getStudentInvoicesSuccess: ['results'],
    getStudentInvoicesError: ['error'],
    createParentRequest: ['studentId', 'info'],
    createParentSuccess: ['response'],
    createParentError: ['error'],
}, {
    prefix: 'CLASSROOMS_',
    defaultActions: {
        get: true,
    },
}, )

const { Types, Creators } = ClassroomRedux
export const ClassroomTypes = Types
export default Creators

export const INITIAL_STATE = createState({
    activeStudentId: 0,
    activeClassroomId: 0,
    activeParentId: 0,
    totalStudents: [],
    searchName: '',
    checkout: false,
    isSearchBarOpen: false,
    sendRequest: {
        fetching: false,
        error: null,
    },
    getInvoices: {
        fetching: false,
        results: {},
        error: null,
    },
    createParent: {
        fetching: false,
        response: {},
        error: null,
    },
    center_id: 0,
    getParent:{
        fetching:false,
        error:null,
    }
}, {
    get: true,
})

/* ------------- Reducers ------------- */
const resetError = state => state.merge({ sendRequest: { fetching: false, error: null } }, d)
const resetClassroom = state => state.merge({ get: { fetching: false, error: null, results: [] } }, d)
    // ----------------------------ACTIVES-------------------------------
const setActiveStudentId = (state, { id }) => state.merge({ activeStudentId: Number(id) }, d)
const setActiveClassroomId = (state, { id }) => state.merge({ activeClassroomId: id }, d)
const setActiveParentId = (state, { id }) => state.merge({ activeParentId: id }, d)
const setUserCenterid = (state, { id }) => state.merge({ center_id: id }, d)
const setSearchName = (state, { name }) => state.merge({ searchName: name }, d)

const setCheckout = (state, { student_id, classroom_id, action }) => {
    const newClassrooms = R.clone(state.get.results)
    const activeClassroomIndex = R.findIndex(R.propEq('id', Number(classroom_id)))(newClassrooms)
    if (activeClassroomIndex > -1) {
        const activeStudentIndex = R.findIndex(R.propEq('id', Number(student_id)))(newClassrooms[activeClassroomIndex].students)
        if (activeStudentIndex > -1) {
            newClassrooms[activeClassroomIndex]
                .students[activeStudentIndex].isComingCheckout = action === "save" ? moment().format('YYYY-MM-DD HH:mm:ss') : null
            newClassrooms[activeClassroomIndex]
                .students[activeStudentIndex].isComingCancel = action === "cancel" ? 'Los papas cancelaron el checkout próximo' : null
            newClassrooms[activeClassroomIndex].students.sort((a) => a.isComingCheckout ? -1 : 1)
        }
    }

    return state.merge({ get: { results: newClassrooms } }, d)
}

const openSearchBar = state => state.merge({ isSearchBarOpen: true }, d)
const closeSearchBar = state => state.merge({ isSearchBarOpen: false }, d)

const getTotalStudents = (state) => {
    if (!state.get.results) {
        return state
    }
    const total = []
    for (let i = 0; i < state.get.results.length; i++) {
        if(state.get.results[i].students !== undefined){
            for (let j = 0; j < state.get.results[i].students.length; j++) {
                total.push({ student: state.get.results[i].students[j], classroom: state.get.results[i].name })
            }
        }
    }
    return state.merge({ totalStudents: total }, d)
}

const searchValue = (state, { value }) => state.merge({ searchValue: value }, d)


// -------------------------STUDENT PROFILE--------------------------

const getStudentProfileRequest = state => state.merge({ get: { fetching: true, error: null } }, d)
const getCenterRequest = state => state.merge({ get: { fetching: true, error: null } }, d)
const getCenterSuccess = (state, { results }) => state.merge({ center_id: results.id }, d)
const getCenterError = (state, { error }) => state.merge({ center_id: null }, d)
const getClassroomRequest = state =>
    state.merge({ get: { fetching: true, error: null } }, d)

const getClassroomSuccess = (state, { results }) =>
    state.merge({ get: { fetching: false, error: null, results } }, d)

const getClassroomError = (state, { error }) =>
    state.merge({ get: { fetching: false, error } }, d)

const getStudentProfileSuccess = (state, { profile, isCheckedOut }) => {
    if (!profile.id || isCheckedOut) {
        return state.merge({ get: { fetching: false } }, d)
    }

    const {
        activeClassroomIndex,
        activeStudentIndex,
        classrooms: newClassrooms,
    } = activeStudentFromLocal(state)

    if (activeStudentIndex >= 0) {
        if (newClassrooms[activeClassroomIndex]) {
            newClassrooms[activeClassroomIndex].students[activeStudentIndex] = profile
        }
    } else {
        newClassrooms[activeClassroomIndex].students.push(profile)
    }

    return state.merge({ get: { fetching: false, results: newClassrooms } }, d)
}

const getStudentProfileError = (state, { err }) =>
    state.merge({ get: { fetching: false, error: err } }, d)

const getStudentProfileErrorReset = state =>
    state.merge({ get: { error: null }, checkout: false }, d)

const getStudentActivitiesRequest = state =>
    state.merge({ get: { fetching: true, error: null } }, d)

const getStudentActivitiesSuccess = (state, { results }) =>
    state.merge({ get: { fetching: false, results } }, d)

const sendMailInstitutionalError = (state, { err }) =>
    state.merge({ sendRequest: { fetching: false, error: err } }, d)

const sendMailInstitutionalRequest = state =>
    state.merge({ sendRequest: { fetching: true, error: null } }, d)

const sendMailInstitutionalSuccess = (state, ) =>
    state.merge({ sendRequest: { fetching: false, error: null } }, d)

// UPDATE STUDENT
const updateStudentRequest = state => state.merge({ get: { fetching: true } }, d)

const updateStudentSuccess = (state, { profile }) => {
    if (!profile.id) {
        return state
    }
    if (state.checkout) {
        return state
    }
    const {
        student,
        activeClassroomIndex,
        activeStudentIndex,
        classrooms: newClassrooms,
        NurseRoomIndex,
    } = activeStudentFromLocal(state)

    let studentUpdated = R.merge(student, profile)
    studentUpdated.profile_pictures= profile.profile_pictures

    if (student.checkin.status === "Nurse's Room") {
        const { classroomIndex, studentIndex } = studentIndexes(state, student)
        const studentInNurseRoomIndex = R.findIndex(R.propEq('id', student.id))(newClassrooms[NurseRoomIndex].students)
        newClassrooms[NurseRoomIndex]
            .students[studentInNurseRoomIndex] = studentUpdated
        newClassrooms[classroomIndex]
            .students[studentIndex] = studentUpdated
    } else {
        newClassrooms[activeClassroomIndex].students[activeStudentIndex] = studentUpdated
    }

    return state.merge({ get: { fetching: false, results: newClassrooms, error:null } }, d)
}

// DELETE Students
const deleteStudentRequest = state =>
    state.merge({ sendRequest: { fetching: true, error: null } }, d)

const deleteStudentSuccess = (state, { response }) => {
    const {
        student: studentDeleted,
        activeClassroomIndex,
        activeStudentIndex,
        classrooms: newClassrooms,
        NurseRoomIndex,
    } = activeStudentFromLocal(state)

    // AQUI SE DA DE BAJA EN EL FRONT
    if (studentDeleted.checkin.status === "Nurse's Room") {
        const { classroomIndex, studentIndex } = studentIndexes(state, studentDeleted)
        const studentInNurseRoomIndex = R.findIndex(R.propEq('id', studentDeleted.id))(newClassrooms[NurseRoomIndex].students)
        studentDeleted.deleted_at = Date.now()
        newClassrooms[NurseRoomIndex]
            .students[studentInNurseRoomIndex] = studentDeleted
        newClassrooms[classroomIndex]
            .students[studentIndex] = studentDeleted
    } else {
        studentDeleted.deleted_at = Date.now()
        newClassrooms[activeClassroomIndex].students[activeStudentIndex] = studentDeleted
    }
    return state
        .merge({ sendRequest: { fetching: false, error: null }, get: { results: newClassrooms } }, d)
}
const deleteStudentError = (state, { error }) =>
    state.merge({ sendRequest: { fetching: false, error } }, d)

// RESTORE STUDENT
const restoreStudentRequest = state => state.merge({ sendRequest: { fetching: true, error: null } }, d)

const restoreStudentSuccess = (state, { response }) => {
    const {
        student: studentRestored,
        activeClassroomIndex,
        activeStudentIndex,
        classrooms: newClassrooms,
    } = activeStudentFromLocal(state)

    studentRestored.deleted_at = null
    newClassrooms[activeClassroomIndex].students[activeStudentIndex] = studentRestored
    return state
        .merge({ sendRequest: { fetching: false, error: null }, get: { results: newClassrooms } }, d)
}
const restoreStudentError = (state, { error }) =>
    state.merge({ sendRequest: { fetching: false, error } }, d)

const updateNotificationsStudent = (state, { disabled_notifications }) => {
        const {
            student: studentRestored,
            activeClassroomIndex,
            activeStudentIndex,
            classrooms: newClassrooms,
        } = activeStudentFromLocal(state)
        newClassrooms[activeClassroomIndex]
            .students[activeStudentIndex]
            .disabled_notifications = disabled_notifications
        return state.merge({ get: { fetching: false, results: newClassrooms } }, d)
    }
    // ----------------------------PARENT PROFILE-------------------------------
const getParentProfileRequest = state => state.merge({ getParent: { fetching: true, error: null } }, d)

const getParentProfileSuccess = (state, { profile }) => {
    if (!profile.id) {
        return state
    }
    const newClassrooms = R.clone(state.get.results)
    const activeClassroomIndex = R.findIndex(R.propEq('id', state.activeClassroomId))(newClassrooms)
    const activeStudentIndex = R.findIndex(R.propEq('id', state.activeStudentId))(newClassrooms[activeClassroomIndex].students)
    let activeParentIndex = R.findIndex(R.propEq('userable_id', state.activeParentId))(newClassrooms[activeClassroomIndex].students[activeStudentIndex].parents)
    if (activeParentIndex === -1) {
        activeParentIndex = R.findIndex(R.propEq('id', state.activeParentId))(newClassrooms[activeClassroomIndex].students[activeStudentIndex].parents)
    }
    const newProfileInfo = {
        relation_id: newClassrooms[activeClassroomIndex]
            .students[activeStudentIndex].parents[activeParentIndex].relation_id
    }

    const profileUpdated = R.merge(profile, newProfileInfo)
    newClassrooms[activeClassroomIndex]
        .students[activeStudentIndex]
        .parents[activeParentIndex] = profileUpdated
    return state.merge({ getParent: { fetching: false,error:null},get:{ results: newClassrooms } }, d)
}

const getParentProfileError = (state, { err }) =>
    state.merge({ getParent: { fetching: false, error: err }, get: { fetching: false } }, d)

const getParentProfileErrorReset = state =>
    state.merge({ get: { fetching: false, error: null } }, d)

const updateParentRequest = state => state.merge({ get: { fetching: true } }, d)

const updateParentSuccess = (state, { profile }) => {
    if (!profile.id) {
        return state
    }
    const newClassrooms = R.clone(state.get.results)
    const activeClassroomIndex = R.findIndex(R.propEq('id', state.activeClassroomId))(newClassrooms)
    const activeStudentIndex = R.findIndex(R.propEq('id', state.activeStudentId))(newClassrooms[activeClassroomIndex].students)
    let activeParentIndex = R.findIndex(R.propEq('userable_id', state.activeParentId))(newClassrooms[activeClassroomIndex].students[activeStudentIndex].parents)
    if (activeParentIndex === -1) {
        activeParentIndex = R.findIndex(R.propEq('id', state.activeParentId))(newClassrooms[activeClassroomIndex].students[activeStudentIndex].parents)
    }
    newClassrooms[activeClassroomIndex]
        .students[activeStudentIndex]
        .parents[activeParentIndex] = profile

    return state.merge({ get: { fetching: false, results: newClassrooms } }, d)
}

// ----------------------------CHECK IN-------------------------------
const updateCheckin = (state, { data, isTeacher }) => {
    if (data.status === 'checked in') {
        const newClassrooms = R.clone(state.get.results)
        const activeClassroomIndex = R.findIndex(R.propEq('id', state.activeClassroomId))(newClassrooms)
        const activeStudentIndex = R.findIndex(R.propEq('id', data.data.latest_health_check.student_id))(newClassrooms[activeClassroomIndex].students)

        const student = newClassrooms[activeClassroomIndex].students[activeStudentIndex]
        const checkinInfo = {
            checkin: {
                id: data.data.id,
                status: data.destination,
            },
            temperature: data.data.latest_health_check.temperature,
            is_virtual_center: data.destination === 'Virtual Center - Advenio',
        }

        const studentUpdated = R.merge(student, checkinInfo)

        newClassrooms[activeClassroomIndex].students[activeStudentIndex] = studentUpdated

        if (data.destination === "Nurse's Room" && !isTeacher) {
            const sickClassroomIndex = R.findIndex(R.propEq('type', 'Sick Room'))(newClassrooms)
            const isInNursesRoom = newClassrooms[sickClassroomIndex].students
                .filter(nurseChild => nurseChild.id === studentUpdated.id)
            if (!isInNursesRoom.length > 0) {
                newClassrooms[sickClassroomIndex].students.push(studentUpdated)
            } else {
                const studentIndex = newClassrooms[sickClassroomIndex].students
                    .findIndex(nurseChild => nurseChild.id === studentUpdated.id)
                newClassrooms[sickClassroomIndex].students[studentIndex] = studentUpdated
            }
        }
        return state.merge({ get: { fetching: false, results: newClassrooms } }, d)
    } else if (data.status === 'sent home') {
        const newClassrooms = R.clone(state.get.results)
        const activeClassroomIndex = R.findIndex(R.propEq('id', state.activeClassroomId))(newClassrooms)
        const activeStudentIndex = R.findIndex(R.propEq('id', data.data.student_id))(newClassrooms[activeClassroomIndex].students)

        const student = newClassrooms[activeClassroomIndex].students[activeStudentIndex]
        const checkinInfo = { checkin: { id: null, status: 'Home' }, temperature: data.data.temperature }

        const studentUpdated = R.merge(student, checkinInfo)

        newClassrooms[activeClassroomIndex].students[activeStudentIndex] = studentUpdated

        return state.merge({ get: { fetching: false, results: newClassrooms } }, d)
    }
    return state
}

const updateVirtualCheckin = (state, { data, student }) => {
    if (data.status === 'checked in') {
        const newClassrooms = R.clone(state.get.results)
        const activeClassroomIndex = data.destination === "Virtual Center - Nurse's Room" ?
            R.findIndex(R.propEq('name', 'Sala de Síntomas'))(newClassrooms) : R.findIndex(R.propEq('id', data.data.classroom.id))(newClassrooms)

        const studentToUpdate = student
        const checkinInfo = {
            checkin: {
                id: data.data.id,
                status: data.destination,
                is_virtual_center: data.destination.startsWith('Virtual Center'),
            },
            temperature: data.data.latest_health_check.temperature,
            is_virtual_center: data.destination.startsWith('Virtual Center'),
        }

        const studentUpdated = R.merge(studentToUpdate, checkinInfo)

        newClassrooms[activeClassroomIndex].students.push(studentUpdated)
        return state.merge({ get: { fetching: false, results: newClassrooms } }, d)
    } else if (data.status === 'sent home') {
        const newClassrooms = R.clone(state.get.results)
        const activeClassroomIndex = R.findIndex(R.propEq('id', data.data.classroom.id))(newClassrooms)

        const studentToUpdate = student
        const checkinInfo = { checkin: { id: null, status: 'Home' }, temperature: data.data.temperature }

        const studentUpdated = R.merge(studentToUpdate, checkinInfo)

        newClassrooms[activeClassroomIndex].students.push(studentUpdated)
        return state.merge({ get: { fetching: false, results: newClassrooms } }, d)
    }
    return state
}

// TODO: Fix this reducer. It seems to unset some attributes, which could have dangerous consequences
const updateDataAfterCheckin = (state, { data, isTeacher }) => {
    const newClassrooms = R.clone(state.get.results)
    const activeClassroomIndex = R.findIndex(
        R.propEq('id', state.activeClassroomId),
    )(newClassrooms)

    const [student] = newClassrooms[activeClassroomIndex]
        .students
        .filter(child => child.checkin.id === data.checkin_id)

    const checkinInfo = {
        checkin: {
            id: student.checkin.id,
            status: student.checkin.status,
            inventory_completed: true,
        },
    }

    const studentUpdated = R.merge(student, checkinInfo, d)

    const activeStudentIndex = R.findIndex(
        R.propEq('id', student.id),
    )(newClassrooms[activeClassroomIndex].students)

    newClassrooms[activeClassroomIndex].students[activeStudentIndex] = studentUpdated

    const InNursesRoom = newClassrooms.filter(room => room.type === 'Sick Room')
    if (InNursesRoom.length > 0) {
        const sickClassroomIndex = R.findIndex(R.propEq('type', 'Sick Room'))(newClassrooms)
        for (let i = 0; i < newClassrooms[sickClassroomIndex].students.length; i += 1) {
            if (student.id === newClassrooms[sickClassroomIndex].students[i].id) {
                newClassrooms[sickClassroomIndex].students[i].checkin.inventory_completed = true
            }
        }
    }

    return state.merge({ get: { fetching: false, results: newClassrooms } }, d)
}

const updateStudentAfterAddSibling = (state, { data }) => {
    const newClassrooms = R.clone(state.get.results)
    const activeClassroomIndex = R.findIndex(
        R.propEq('id', state.activeClassroomId),
    )(newClassrooms)
    const [student] = newClassrooms[activeClassroomIndex]
        .students
        .filter(child => child.id === state.activeStudentId)

    const newSibling = {
        id: data.id,
        birth_date: data.birth_date,
        center: data.center,
        classroom_id: data.classroom_id,
        name: data.first_name + ' ' + data.last_name_paternal + ' ' + data.last_name_maternal,
        status: data.status,
    }

    const studentUpdated = student.siblings.push(newSibling)
    newClassrooms[activeClassroomIndex].students.push(studentUpdated)

    return state.merge({ get: { fetching: false, results: newClassrooms } }, d)
}

// ----------------------------CHECK OUT-------------------------------
const updateDataAfterCheckout = (state, { data, isTeacher }) => {
    const newClassrooms = R.clone(state.get.results)
    const {
        student,
        activeClassroomIndex,
        activeStudentIndex,
        NurseRoomIndex,
    } = activeStudentFromLocal(state)
    if (!student.classroom_id) {
        student.classroom_id = state.activeClassroomId
    }
    const checkinInfo = {
        checkin: {
            id: null,
            status: 'Inactive',
            inventory_completed: false,
        },
    }
    let studentUpdated = {}
    if (student.checkin.is_virtual_center) {
        newClassrooms[activeClassroomIndex]
            .students
            .splice(activeStudentIndex, 1)
    } else if (student.checkin.status === "Nurse's Room" && !isTeacher) {
        const { classroomIndex, studentIndex } = studentIndexes(state, student, isTeacher)
        const studentInNurseRoomIndex = R.findIndex(R.propEq('id', student.id))(newClassrooms[NurseRoomIndex].students)
        studentUpdated = R.merge(student, checkinInfo, d)
        newClassrooms[NurseRoomIndex]
            .students
            .splice(studentInNurseRoomIndex, 1)
        newClassrooms[classroomIndex]
            .students[studentIndex] = studentUpdated
    } else {
        studentUpdated = R.merge(student, checkinInfo, d)
        newClassrooms[activeClassroomIndex]
            .students[activeStudentIndex] = studentUpdated
    }


    return state.merge({ get: { fetching: false, results: newClassrooms }, checkout: true }, d)
}

// ----------------------------ACTIVITY-------------------------------
const updateChildActivity = (state, { data }) => {
    let isValid = false
    let date = null
    const newClassrooms = R.clone(state.get.results)
    const activeClassroomIndex = R.findIndex(R.propEq('id', state.activeClassroomId))(newClassrooms)
    const [student] = newClassrooms[activeClassroomIndex].students
        .filter(child => child.checkin.id === data.checkin_id)
    Object.keys(student.latest_activities).map((value) => {
        if (moment(value, 'YYYY-MM-DD', true).isValid()) {
            isValid = true
            date = value
        }
    })
    if (data.finished_at) {
        if (isValid) {
            student.latest_activities[date].unshift({
                ...data,
            })
        } else {
            student.latest_activities.unshift({
                id: data.id,
                started_at: data.started_at,
                finished_at: data.finished_at,
                category_id: data.category_id,
                type_id: data.type_id,
                ...data,
            })
        }
    } else {
        if (isValid) {
            student.latest_activities[date].unshift({
                ...data,
            })
        } else {
            student.latest_activities.unshift({
                id: data.id,
                started_at: data.started_at,
                finished_at: null,
                category_id: data.category_id,
                type_id: data.type_id,
                ...data,
            })
        }
    }

    const activeStudentIndex = R.findIndex(R.propEq('id', student.id))(newClassrooms[activeClassroomIndex].students)
    newClassrooms[activeClassroomIndex].students[activeStudentIndex] = student
    return state.merge({ get: { fetching: false, results: newClassrooms }, newActivity: true }, d)
}

const updateChildGroupActivity = (state, { data }) => {
    const children = []
    const newClassrooms = R.clone(state.get.results)
    const activeClassroomIndex = R.findIndex(R.propEq('id', state.activeClassroomId))(newClassrooms)
    for (let i = 0; i < data.length; i++) {
        const [student] = newClassrooms[activeClassroomIndex].students
            .filter(child => child.checkin.id === data[i].checkin_id)
        if (student) {
            children.push(student)
        }
    }
    if (data[0].finished_at) {
        for (let i = 0; i < children.length; i += 1) {
            children[i].latest_activities.unshift({
                id: data[i].id,
                started_at: data[i].started_at,
                finished_at: data[i].finished_at,
                category_id: data[i].category_id,
                type_id: data[i].type_id,
            })
        }
    } else {
        for (let i = 0; i < children.length; i += 1) {
            children[i].latest_activities.unshift({
                id: data[i].id,
                started_at: data[i].started_at,
                finished_at: null,
                category_id: data[i].category_id,
                type_id: data[i].type_id,
            })
        }
    }
    for (let i = 0; i < children.length; i += 1) {
        const activeStudentIndex = R.findIndex(R.propEq('id', children[i].id))(newClassrooms[activeClassroomIndex].students)
        newClassrooms[activeClassroomIndex].students[activeStudentIndex] = children[i]
    }
    return state.merge({ get: { fetching: false, results: newClassrooms } }, d)
}

const updateChildAfterFinishActivity = (state, { results }) =>
    state.merge({ get: { fetching: false, results } }, d)

const deleteActivity = (state, { activityId }) => {
    let date = null
    const newClassrooms = R.clone(state.get.results)
    const { student, activeClassroomIndex, activeStudentIndex } = activeStudentFromLocal(state)
    Object.keys(student.latest_activities).map((key) => {
        date = key
    })
    const latestActivitiesIndex = R.findIndex(R.propEq('id', activityId))(student.latest_activities[date])
    student.latest_activities[date].splice(latestActivitiesIndex, 1)
    newClassrooms[activeClassroomIndex].students[activeStudentIndex] = student
    return state.merge({ get: { fetching: false, results: newClassrooms } }, d)
}

const updateDataAfterInscription = (state, { data }) => {
    const newClassrooms = R.clone(state.get.results)
    const id = parseInt(data.classroom_id)
    const activeClassroomIndex = R.findIndex(R.propEq('id', id))(newClassrooms)
    const checkinInfo = { checkin: { id: null, status: 'Inactive', inventory_completed: false } }
    const studentUpdated = R.merge(data, checkinInfo, d)
    newClassrooms[activeClassroomIndex].students.push(studentUpdated)
    return state.merge({ get: { fetching: false, results: newClassrooms } }, d)
}

const getStudentInvoicesRequest = state =>
    state.merge({ getInvoices: { fetching: true, error: null } }, d)

const getStudentInvoicesSuccess = (state, { results }) =>
    state.merge({ getInvoices: { fetching: false, results } }, d)

const getStudentInvoicesError = (state, { error }) =>
    state.merge({ getInvoices: { fetching: false, error } }, d)

const createParentRequest = state =>
    state.merge({ createParent: { fetching: true, error: null } }, d)

const createParentSuccess = (state, { response }) => {
    const classroomIndex = state.get.results.findIndex(c =>
        c.id === state.activeClassroomId)

    const studentIndex = state.get.results[classroomIndex].students.findIndex(s =>
        s.id === state.activeStudentId)

    const newGet = R.clone(state.get.results)
    newGet[classroomIndex].students[studentIndex].parents.push(response.data)

    return state.merge({
        createParent: { fetching: false, response },
        get: { results: newGet },
    }, d)
}

const createParentError = (state, { error }) =>
    state.merge({ createParent: { fetching: false, error } }, d)

// --------------------------MAIN REDUCER ------------------------------------------
export const reducer = createReducer(
    INITIAL_STATE, {
        [Types.setActiveStudentId]: setActiveStudentId,
        [Types.setActiveClassroomId]: setActiveClassroomId,
        [Types.setActiveParentId]: setActiveParentId,
        [Types.setUserCenterid]: setUserCenterid,
        [Types.setCheckout]: setCheckout,
        [Types.getStudentProfileRequest]: getStudentProfileRequest,
        [Types.getStudentProfileSuccess]: getStudentProfileSuccess,
        [Types.getStudentProfileError]: getStudentProfileError,
        [Types.getCenterRequest]: getCenterRequest,
        [Types.getCenterSuccess]: getCenterSuccess,
        [Types.getCenterError]: getCenterError,
        [Types.getClassroomRequest]: getClassroomRequest,
        [Types.getClassroomSuccess]: getClassroomSuccess,
        [Types.getClassroomError]: getClassroomError,
        [Types.getStudentActivitiesRequest]: getStudentActivitiesRequest,
        [Types.getStudentActivitiesSuccess]: getStudentActivitiesSuccess,
        [Types.getStudentActivitiesError]: getStudentProfileError,
        [Types.getStudentProfileErrorReset]: getStudentProfileErrorReset,
        [Types.getParentProfileRequest]: getParentProfileRequest,
        [Types.getParentProfileSuccess]: getParentProfileSuccess,
        [Types.getParentProfileError]: getParentProfileError,
        [Types.getParentProfileErrorReset]: getParentProfileErrorReset,
        [Types.updateStudentRequest]: updateStudentRequest,
        [Types.updateParentRequest]: updateParentRequest,
        [Types.updateStudentSuccess]: updateStudentSuccess,
        [Types.updateParentSuccess]: updateParentSuccess,
        [Types.updateCheckin]: updateCheckin,
        [Types.updateVirtualCheckin]: updateVirtualCheckin,
        [Types.updateDataAfterCheckin]: updateDataAfterCheckin,
        [Types.updateDataAfterCheckout]: updateDataAfterCheckout,
        [Types.updateChildActivity]: updateChildActivity,
        [Types.updateChildGroupActivity]: updateChildGroupActivity,
        [Types.updateChildAfterFinishActivity]: updateChildAfterFinishActivity,
        [Types.deleteActivity]: deleteActivity,
        [Types.deleteStudentRequest]: deleteStudentRequest,
        [Types.deleteStudentSuccess]: deleteStudentSuccess,
        [Types.deleteStudentError]: deleteStudentError,
        [Types.restoreStudentRequest]: restoreStudentRequest,
        [Types.restoreStudentSuccess]: restoreStudentSuccess,
        [Types.restoreStudentError]: restoreStudentError,
        [Types.updateDataAfterInscription]: updateDataAfterInscription,
        [Types.updateNotificationsStudent]: updateNotificationsStudent,
        [Types.updateStudentAfterAddSibling]: updateStudentAfterAddSibling,
        [Types.openSearchBar]: openSearchBar,
        [Types.closeSearchBar]: closeSearchBar,
        [Types.searchValue]: searchValue,
        [Types.getTotalStudents]: getTotalStudents,
        [Types.resetError]: resetError,
        [Types.resetClassroom]: resetClassroom,
        [Types.setSearchName]: setSearchName,
        [Types.getStudentInvoicesRequest]: getStudentInvoicesRequest,
        [Types.getStudentInvoicesSuccess]: getStudentInvoicesSuccess,
        [Types.getStudentInvoicesError]: getStudentInvoicesError,
        [Types.createParentRequest]: createParentRequest,
        [Types.createParentSuccess]: createParentSuccess,
        [Types.createParentError]: createParentError,
        [Types.sendMailInstitutionalError]: sendMailInstitutionalError,
        [Types.sendMailInstitutionalRequest]: sendMailInstitutionalRequest,
        [Types.sendMailInstitutionalSuccess]: sendMailInstitutionalSuccess,
    }, {
        defaultActions: {
            get: true,
        },
        Types,
    },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/ClassroomRedux.js